import { sessionApi } from '@shared/api/server'

import { UserInfoType } from '../type'
import { SessionModel } from './session.model'

export interface ISessionRepository {
  update(): Promise<{ session: SessionModel; info: UserInfoType }>
  remove(): Promise<void>
  create(
    username: string,
    password: string
  ): Promise<{ session: SessionModel; info: UserInfoType }>
}

export class SessionRepository implements ISessionRepository {
  async update(): Promise<{ session: SessionModel; info: UserInfoType }> {
    const response = await sessionApi.refreshTokenCall()
    if (response.accessToken) {
      const { accessToken, ...rest } = response
      return {
        session: new SessionModel(response.accessToken),
        info: rest
      }
    }
    throw new Error('Не удалось получить новый токен')
  }

  async create(
    username: string,
    password: string
  ): Promise<{ session: SessionModel; info: UserInfoType }> {
    const session = await sessionApi.signInCall({ username, password })
    const { accessToken, ...rest } = session
    return {
      session: new SessionModel(session.accessToken),
      info: rest
    }
  }

  async remove(): Promise<void> {
    return await sessionApi.logoutCall()
  }
}
